import { QuickLinks } from './quick-links';
import { FilterService } from '../../../services/filter.service';
import { Filter } from '../../../models/review/filter.model';

export class FilterQuickLinks extends QuickLinks {

  constructor(private filterService: FilterService) {
    super();
  }

  initialize() {
    this.filterService.getFilters().subscribe((data: Filter[]) => {
      if (data) super.set(data);
    });
  }
}
